// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentTotalAmount.MuiTypography-root {
    font-weight: 500;
    font-size: 32px;
    line-height: 46px;
    letter-spacing: 0%;
    color: #010102EB;
}

.partnerFormContainer {
    /* padding: 10px 24px; */
    height: 250px;
    overflow-y: scroll;
    padding-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/orderManagement/OrderDetails/splitPayment/splitPayment.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;AACxB","sourcesContent":[".paymentTotalAmount.MuiTypography-root {\n    font-weight: 500;\n    font-size: 32px;\n    line-height: 46px;\n    letter-spacing: 0%;\n    color: #010102EB;\n}\n\n.partnerFormContainer {\n    /* padding: 10px 24px; */\n    height: 250px;\n    overflow-y: scroll;\n    padding-bottom: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
